/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useState, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import {
  formatDate,
  getNewDate,
  isEmpty,
  isMobileWidth,
} from '../../helper-utils/appUtils';
import AppSidebar from '../app-sidebar/AppSidebar';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  TODAY_DATE,
} from '../../constants/Constants';

const CustomDatePickerInput = forwardRef(
  ({ value, onClick, placeholder }, ref) => (
    <input
      value={value}
      onClick={onClick}
      ref={ref}
      placeholder={placeholder}
      readOnly
      style={{ cursor: 'pointer' }}
    />
  ),
);

function AppDatePicker({
  name,
  label,
  selectedDate,
  onChange,
  placeholder,
  minDate,
  maxDate,
  disabled,
  className,
  customClassName,
  monthsShown,
  labelClassName,
  valueClassName,
  showPreviousMonths,
  customMobileClass,
  showDay,
  required,
  isCustomeInput,
  ...rest
}) {
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  const handleMobileOnchange = (date) => {
    onChange(date);
    setShowMobilePopup(false);
  };
  return !isMobileWidth() ? (
    <div
      className={customClassName}
      style={{ backgroundColor: disabled ? '#E9E9E9' : '#fff' }}
    >
      <label
        htmlFor={name}
        className={`app-date-label ${
          required ? 'required' : ''
        } ${labelClassName}`}
      >
        {label}
      </label>
      <DatePicker
        monthsShown={monthsShown}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        selected={selectedDate}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        customInput={
          isCustomeInput && <CustomDatePickerInput placeholder={placeholder} />
        }
        disabled={disabled}
        calendarClassName={className}
        {...rest}
      />
      {showDay && !isEmpty(selectedDate) && (
        <span style={{ marginTop: '-2px' }}>
          {formatDate(getNewDate(selectedDate), 'dddd')}
        </span>
      )}
    </div>
  ) : (
    <>
      <div
        onClick={() => setShowMobilePopup(true)}
        className={`app-mobile-datepicker-style ${customMobileClass}`}
      >
        <label htmlFor={name} className={labelClassName}>
          {label}
        </label>
        <span className={valueClassName}>
          {selectedDate &&
            formatDate(getNewDate(selectedDate), DATE_MONTH_YEAR_VIEW_FORMAT)}
        </span>
      </div>
      {!disabled && showMobilePopup && (
        <AppSidebar
          sidebarTitle={label}
          onHideSidebar={() => setShowMobilePopup(false)}
          animatedClass="slide-from-right-animation"
          className="app-mobile-datepicker-modal"
        >
          <DatePicker
            openToDate={getNewDate(TODAY_DATE)}
            monthsShown={monthsShown}
            dateFormat="dd/MM/yyyy"
            placeholderText={placeholder}
            selected={selectedDate}
            showPreviousMonths={showPreviousMonths}
            onChange={handleMobileOnchange}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            inline
            customInput={isCustomeInput && <CustomDatePickerInput />}
            disabledKeyboardNavigation
            disabledDayAriaLabelPrefix
            calendarClassName={` app-mobile-datepicker-modal ${className}`}
            {...rest}
          />
        </AppSidebar>
      )}
    </>
  );
}

AppDatePicker.defaultProps = {
  minDate: '',
  maxDate: '',
  showPreviousMonths: false,
  disabled: false,
  className: '',
  customClassName: '',
  name: '',
  label: '',
  monthsShown: isMobileWidth() ? 12 : 1,
  labelClassName: '',
  valueClassName: ' ',
  placeholder: '',
  customMobileClass: '',
  required: false,
  showDay: undefined,
  isCustomeInput: true,
};

AppDatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  disabled: PropTypes.bool,
  showPreviousMonths: PropTypes.bool,
  className: PropTypes.string,
  monthsShown: PropTypes.number,
  customClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  selectedDate: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showDay: PropTypes.bool,
  customMobileClass: PropTypes.any,
  required: PropTypes.bool,
  isCustomeInput: PropTypes.bool,
  valueClassName: PropTypes.string,
};
export default AppDatePicker;
